export const createPublicSpecialEventOffer = (event, context) => ({
  accessEndsAt: event.endDatetime,
  accessStartsAt: event.startDatetime,
  autoRenew: false,
  channelId: event.rtvChannelId,
  channelName: context.channel ? context.channel.name : '',
  contentEndsAt: event.contentEndDatetime || event.endDatetime,
  contentStartsAt: event.contentStartDatetime || event.startDatetime,
  eventId: event.id,
  kind: 'rtv_special_event',
  partnerId: event.uid,
  priceEur: context.priceCents / 100
});

const formatDate = (value, locale) => new Date(value).toLocaleDateString(locale);

export const createPublicSpecialEventPresentation = (offer, locale) => ({
  accessHelpKey: 'PUBLIC_CATALOG_SPECIAL_EVENT_ALREADY_HAVE_ACCESS_HELP',
  actionKey: 'SPECIAL_EVENT_BUY_ACTION',
  benefits: [
    {
      key: 'REPLAYER_TV_SPECIAL_EVENT_DURATION',
      values: {
        end: formatDate(offer.accessEndsAt, locale),
        start: formatDate(offer.accessStartsAt, locale)
      }
    },
    {
      key: 'REPLAYER_TV_SPECIAL_EVENT_CONTENT_WINDOW',
      values: {
        end: formatDate(offer.contentEndsAt, locale),
        start: formatDate(offer.contentStartsAt, locale)
      }
    },
    {key: 'PUBLIC_CATALOG_NO_AUTO_RENEWAL'}
  ],
  introKey: 'PUBLIC_CATALOG_SPECIAL_EVENT_OPTIONS_INTRO',
  modalTitleKey: 'PUBLIC_CATALOG_SPECIAL_EVENT_OPTIONS',
  priceSuffixKey: 'PUBLIC_CATALOG_ONE_TIME',
  titleKey: 'SPECIAL_EVENT'
});

export const createPublicSpecialEventPaywallPresentation = (paywallOffer, locale) => {
  if (
    !paywallOffer
    || paywallOffer.contentType !== 'special_event'
    || !paywallOffer.offers
    || !Array.isArray(paywallOffer.offers.subscriptions)
  ) {
    return null;
  }
  const offer = paywallOffer.offers.subscriptions.find(subscription => (
    subscription.kind === 'rtv_special_event'
  ));
  return offer ? createPublicSpecialEventPresentation(offer, locale) : null;
};
